import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

import { DashboardOnboardingBanner } from '../DashboardOnboardingBanner';

interface Props {
  firstName?: string | null;
  email?: string | null;
  teamName: string;
}

// Surfaces the awaiting_approval team-join state on the dashboard.
//
// Intentional dead-end at v1: no in-app cancel-request or contact-owner
// action is provided. The expectation is that a user who requested to join
// a team already knows who their team owner / admin is and can reach out
// directly, or contact OnFrontiers support if the owner is unreachable. A
// self-service "cancel join request → create own team instead" path is
// tracked as a v2 follow-up — adding it requires a new API mutation and
// changes the team-uniqueness invariant that the partner flow relies on.
export function PendingTeamApprovalBanner({ firstName, email, teamName }: Props): JSX.Element {
  return (
    <DashboardOnboardingBanner
      firstName={firstName}
      email={email}
      subheading={
        <>
          Your email matches an existing team on OnFrontiers. You&apos;ll be added to the workspace
          as soon as your request is approved.
        </>
      }
      chipLabel="Waiting for approval"
      title={`Your request to join ${teamName} has been sent`}
      body={
        <>
          A team owner needs to approve your request before you can access the workspace. Sign in
          any time to check your status.
        </>
      }
      leadingIcon={
        <HourglassEmptyIcon sx={{ color: 'var(--brandPrimary)', fontSize: 28, flexShrink: 0 }} />
      }
    />
  );
}
